import { useEffect } from "react"
import { _BoardColumns, _single } from "../../../core/services/dataBean/EntityCatalog"
import useDataBean from "../../../core/services/dataBean/useDataBean"
import useModal, { MODAL_LG, MODAL_md, MODAL_SM } from "../../theme/Component/hooks/useModal"
import { toast } from "react-toastify"
import { ListMenu } from "../../theme/Component/ListMenu"
import { BasicPage } from "../../theme/Component/BasicPage"
import { BasicTable } from "../../theme/Component/BasicTable"
import { Modal } from "../../theme/Component/Modal"
import { ModalConfirm } from "../../theme/Component/ModalConfirm"
import { BoardColumnStatuses } from "./BoardColumnStatuses/BoardColumnStatuses"
import { InputColor } from "../../theme/Input/InputColor"

export const BoardColumns = () => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_BoardColumns)

    const modal = useModal("", MODAL_md);
    const modalC = useModal("Eliminar columna de la tabla", MODAL_SM);
    const modalStatus = useModal("Estados relacionados de las Columnas", MODAL_LG);

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {
        const props = {
            State: 1
        }

        instance.getBoardColumnsCatalogPorPropiedades(props, null).then(
            (resp: any) => {
                setLista(resp);
            }
        ).catch(err => {
            toast.error("Error al cargar la lista de columnas");
        });
    };

    const create = () => {
        setBean({
            State: 1,
            IDEmployee: _single.getAccountID(),
            HeaderColor: "#f6f7f9",
        });
        modal.open("Agregar Columna de tabla")
    }

    const deleteItem = () => {
        const x = { ...bean, State: 2 };
        editaItem(x);
    };

    const editaItem = (obj: any) => {
        instance.updateBoardColumns(obj).then(
            (resp: any) => {
                getLista();
                modal.close();
                modalC.close()
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const head = [
        { title: 'ID', property: 'IDBoardColumns', visible: true },
        { title: 'Nombre de la Columnas', property: 'BoardColumnsName', visible: true },
        { title: 'Posición', property: 'Position', visible: true },
        { title: 'Color', property: 'HeaderColor', visible: true },
    ];


    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modal.open(`Editar con ${bean.BoardColumnsName}`) } },
            { titulo: 'Relacion de Estados', icono: 'ri-list-check', visible: _single.canDelete(), evento: () => { modalStatus.open() } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalC.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (
        <BasicPage titulo="Columnas de las tablas">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} />

                    <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { editaItem(bean) }}>
                        <div className="row">
                            <div className="col-md-12">
                                <label>Nombre de la Columna</label>
                                <input type="text" className="form-control" value={bean.BoardColumnsName} onChange={(e) => { setBean({ ...bean, BoardColumnsName: e.target.value }) }} />
                            </div>

                            <div className="col-md-12">
                                <label>Posicion de la columna</label>
                                <input type="number" className="form-control" value={bean.Position} onChange={(e) => {
                                    const valor = e.target.value ? parseInt(e.target.value) : null;
                                    setBean({ ...bean, Position: valor })
                                }} />
                            </div>

                            <div className="col-md-12">
                                <InputColor onChange={(e) => { setBean({ ...bean, HeaderColor: e }) }} value={bean.HeaderColor} label="Color de la Etiqueta" />
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalStatus.modal} updateModal={modalStatus.setModal}>
                        <BoardColumnStatuses idColumnBoard={bean.IDBoardColumns} />
                    </Modal>

                    <ModalConfirm modal={modalC.modal} updateModal={modalC.setModal} eventModal={deleteItem}>
                        <strong>Eliminar item {bean.BoardColumnsName}</strong>
                    </ModalConfirm>
                </div>
            </div>
        </BasicPage>
    )
}